import classNames from "classnames";
import React from "react";
import { findDataAttrProps } from "../../utils/props";
import styles from "./Text.module.scss";

export type TextVariant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "default"
  | "defaultLight"
  | "defaultBold"
  | "defaultTiny"
  | "blockquote"
  | "footerHeading"
  | "footerDefault"
  | "filterInfo"
  | "filterHeading"
  | "filter"
  | "filterWhenSelected"
  | "filterWhenNotSelected"
  | "subtitle"
  | "toolbarDefault"
  | "toolbarDefaultBold"
  | "toolbarDefaultLight"
  | "toolbarWhenSelected"
  | "mobileToolbarDefault"
  | "mobileToolbarWhenSelected"
  | "mobileToolbarTertiary"
  | "breadcrumb"
  | "button";

const variantMapping: { [K in TextVariant]: string } = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  default: "p",
  defaultLight: "p",
  defaultBold: "p",
  defaultTiny: "p",
  blockquote: "span",
  footerHeading: "h3",
  footerDefault: "span",
  filterInfo: "span",
  filterHeading: "h4",
  filter: "span",
  filterWhenSelected: "span",
  filterWhenNotSelected: "span",
  toolbarWhenSelected: "span",
  mobileToolbarDefault: "span",
  toolbarDefault: "span",
  toolbarDefaultBold: "span",
  toolbarDefaultLight: "span",
  mobileToolbarWhenSelected: "span",
  mobileToolbarTertiary: "span",
  breadcrumb: "span",
  button: "span",
  subtitle: "p"
};

export interface TextProps {
  variant: TextVariant;
  children: React.ReactNode;
  className?: string;
  color?: "black" | "deep-pink" | "iris" | "white";
  as?: string;
  gutterBottom?: boolean;
  style?: React.CSSProperties;
  // tslint:disable-next-line: no-any
  [propName: string]: any;
}

const Text = (props: TextProps) => {
  const {
    children,
    style,
    className,
    color,
    as,
    gutterBottom = false,
    variant,
    ...other
  } = props;
  // tslint:disable-next-line: no-any
  const Component = (as || variantMapping[variant]) as any;
  return (
    <Component
      {...other}
      {...findDataAttrProps(props)}
      style={style}
      className={classNames(
        color && styles[color],
        styles[variant],
        gutterBottom && styles.gutterBottom,
        className
      )}
    >
      {children}
    </Component>
  );
};

export default Text;
